import React from 'react'
import { TbLoader } from 'react-icons/tb/index.js'

export default function DefaultLoaderIcon() {
    return (
        <TbLoader className="upup-animate-spin upup-text-3xl upup-text-[#6D6D6D]" />
    )
}
